import {
  CircularProgress,
  Container,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Typography,
} from "@mui/material";
import ProgressTracker from "../../../../ui/components/ProgressTracker";
import { useStudentClassesAndAttendance } from "../../api/getStudentClassesAndAttendance";
import CustomTable from "../../../../ui/components/Table";
import moment from "moment";
const StudentClassesAndAttendances = ({ enrollmentId }) => {
  const { data, isLoading } = useStudentClassesAndAttendance({ enrollmentId });
  if (isLoading) {
    return <CircularProgress />;
  }

  return (
    <CustomTable>
      <TableHead>
        <TableRow>
          <TableCell>
            <Typography>Data</Typography>
          </TableCell>
          <TableCell>
            <Typography>Tipo</Typography>
          </TableCell>
          <TableCell>
            <Typography>Duração</Typography>
          </TableCell>
          <TableCell>
            <Typography>Participação</Typography>
          </TableCell>
        </TableRow>
      </TableHead>
      <TableBody>
        {data.map((_class) => {
          return (
            <TableRow>
              <TableCell>
                {moment(_class.startDate, "DD-MM-YYYY HH:mm:ss").format("lll")}
              </TableCell>
              <TableCell>{_class.type}</TableCell>
              <TableCell>{_class.duration} minutos</TableCell>
              <TableCell>{_class.minutesOnParticipation || "-"}</TableCell>
            </TableRow>
          );
        })}
      </TableBody>
    </CustomTable>
  );
};

export { StudentClassesAndAttendances };
